import Link from "@components/Link";
import { menuList } from "@src/app/components/Header";
import Share from "@src/app/components/SocialMedia";
import { useMenuHeight } from "@src/app/hooks/useMenuHeight";
import clsx from "clsx";
import { type ReactElement, useContext, useRef } from "react";

import { ThemeContext, ThemeEnum } from "../ThemeProvider/ThemeProvider";

interface MenuProps {
  visible?: boolean;
}

export default function Menu({ visible = false }: MenuProps): ReactElement {
  const { theme } = useContext(ThemeContext);
  const menuRef = useRef<HTMLDivElement>(null);

  const menuHeight = useMenuHeight(menuRef);

  return (
    <section
      ref={menuRef}
      style={{
        height: menuHeight,
        transition: "transform 0.4s cubic-bezier(0.4,0,0.2,1)",
        transform: visible ? "translateX(0)" : "translateX(-100%)",
      }}
      className={clsx(
        "fixed inset-x-0 z-[999] flex w-screen flex-col",
        theme === ThemeEnum.dark ? "bg-inverse" : "bg-secondary",
      )}
      data-testid="redants-menu"
    >
      <section
        className={clsx(
          "z-[1000] w-full border-b border-solid px-[16px] py-[20px]",
          theme === ThemeEnum.dark ? "text-primary-on-dark" : "text-primary",
          theme === ThemeEnum.dark ? "bg-inverse" : "bg-secondary",
          theme === ThemeEnum.dark
            ? "border-b-0"
            : "border-b-[divide-divider-secondary]",
        )}
      >
        {menuList.map((item, index) => (
          <Link
            className="mb-[20px] flex w-full px-[12px] py-[4px] text-button-1 last:mb-0"
            key={index}
            to={item.path}
            data-testid={`menu-${item.name}`}
          >
            {item.name}
          </Link>
        ))}
      </section>
      <section
        className={clsx(
          "box-border flex flex-col items-center border-b border-solid p-[16px]",
          theme === ThemeEnum.dark
            ? "border-b-0"
            : "border-b-[divide-divider-secondary]",
        )}
      >
        <p
          className={clsx(
            "mb-[16px] text-subheader text-primary",
            theme === ThemeEnum.dark ? "text-primary-on-dark" : "text-primary",
          )}
        >
          在不同平台获取最新新闻
        </p>
        <Share />
      </section>
    </section>
  );
}
